<template>
  <layout-content :total="total">
    <!-- 面包屑的插槽 -->
    <breadcrumb slot="breadcrumb"></breadcrumb>
    <div slot="content">
      <!-- 搜索和新增删除 -->
      <div class="d-f a-c j-b">
        <a-form-model ref="queryForm" :model="queryParams" layout="inline">
          <a-form-model-item label="参数名称" prop="configName">
            <a-input
              v-model="queryParams.configName"
              placeholder="请输入参数名称"
              allowClear
              @keyup.enter.native="handleQuery"
            />
          </a-form-model-item>
          <a-form-model-item label="参数键名" prop="configKey">
            <a-input
              v-model="queryParams.configKey"
              placeholder="请输入参数键名"
              allowClear
              @keyup.enter.native="handleQuery"
            />
          </a-form-model-item>
          <a-form-model-item>
            <a-button
              type="primary"
              @click="handleQuery"
              v-hasPermi="['setting:config:query']"
              >搜索</a-button
            >
            <a-button
              @click="resetQuery"
              class="ml10"
              v-hasPermi="['setting:config:query']"
              >重置</a-button
            >
            <a-button
              @click="refreshCache"
              class="ml10"
              v-hasPermi="['setting:config:query']"
              >刷新缓存</a-button
            >
          </a-form-model-item>
        </a-form-model>
        <div>
          <a-button
            type="primary"
            @click="handleAdd"
            icon="plus"
            v-hasPermi="['setting:config:add']"
            >新增</a-button
          >
          <a-button
            @click="handleDelete"
            icon="delete"
            class="ml10"
            :disabled="multiple"
            v-hasPermi="['setting:config:remove']"
          >
            批量删除
          </a-button>
        </div>
      </div>
      <!--表格-->
      <a-table
        :columns="columns"
        rowKey="id"
        :data-source="data"
        :pagination="false"
        :row-selection="{
          selectedRowKeys: selectedRowKeys,
          onChange: onSelectChange,
        }"
        class="mt20"
      >
        <span slot="configType" slot-scope="text">
          <a-tag color="#009FE8">
            {{ dictTranslation(configTypeList, text) }}
          </a-tag>
        </span>
        <span slot="action" slot-scope="text, record">
          <a @click="handleUpdate(record)" v-hasPermi="['setting:config:edit']">编辑</a>
          <a-divider type="vertical" />
          <a @click="handleDelete(record)" v-hasPermi="['setting:config:remove']">删除</a>
        </span>
      </a-table>
      <!--分页-->
      <div class="d-f mt20">
        <a-pagination
          v-model="queryParams.page"
          :pageSize="queryParams.limit"
          :default-current="1"
          :total="total"
          :hideOnSinglePage="true"
          showLessItems
          @change="onChange"
          :item-render="itemRender"
          style="margin-left: auto"
        />
      </div>
      <!--新增和编辑的弹出框-->
      <a-modal
        v-model="visible"
        :title="title"
        @ok="submit"
        @cancel="handleCancel"
        width="500px"
      >
        <a-form-model
          ref="ruleForm"
          :model="form"
          :rules="rules"
          :label-col="labelCol"
          :wrapper-col="wrapperCol"
        >
          <a-row>
            <a-col :span="24">
              <a-form-model-item label="参数名称" prop="configName">
                <a-input v-model="form.configName" placeholder="请输入参数名称" />
              </a-form-model-item>
            </a-col>
            <a-col :span="24">
              <a-form-model-item label="参数键名" prop="configKey">
                <a-input v-model="form.configKey" placeholder="请输入参数键名" />
              </a-form-model-item>
            </a-col>
            <a-col :span="24">
              <a-form-model-item label="参数键值" prop="configValue">
                <a-input v-model="form.configValue" placeholder="请输入参数键值" />
              </a-form-model-item>
            </a-col>
            <a-col :span="24">
              <a-form-model-item label="系统内置" prop="configType">
                <a-radio-group v-model="form.configType">
                  <a-radio
                    :value="item.valueData"
                    v-for="item in configTypeList"
                    :key="item.id"
                  >
                    {{ item.valueName }}
                  </a-radio>
                </a-radio-group>
              </a-form-model-item>
            </a-col>
            <a-col :span="24">
              <a-form-model-item label="备注" prop="remark">
                <a-input
                  v-model="form.remark"
                  type="textarea"
                  :rows="6"
                  :maxLength="200"
                />
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-form-model>
      </a-modal>
    </div>
  </layout-content>
</template>

<script>
import LayoutContent from "@/views/layout/content";
import Breadcrumb from "~c/Breadcrumb";
import {
  getConfigList,
  refreshCache,
  configAddOrUpdate,
  configRemove,
  getConfig,
} from "@/api/setting/config.js";
const columns = [
  {
    title: "参数名称",
    dataIndex: "configName",
    align: "center",
  },
  {
    title: "参数键名",
    dataIndex: "configKey",
    align: "center",
  },
  {
    title: "参数键值",
    dataIndex: "configValue",
    align: "center",
  },
  {
    title: "系统内置",
    dataIndex: "configType",
    align: "center",
    scopedSlots: { customRender: "configType" },
  },
  {
    title: "操作",
    dataIndex: "action",
    align: "center",
    scopedSlots: { customRender: "action" },
  },
];
export default {
  name: "Config",
  components: { LayoutContent, Breadcrumb },
  data() {
    return {
      total: null,
      // 查询参数
      queryParams: {
        //当前页
        page: 1,
        //一页几个
        limit: 10,
      },
      //表格的表头文字
      columns,
      //表格的数据
      data: [],
      //多选的数据
      selectedRowKeys: [],
      // 非多个禁用
      multiple: true,
      //新增和编辑的表单
      form: {},
      //表单规则
      rules: {
        configName: [
          {
            required: true,
            message: "请输入参数名称",
            whitespace: true,
            trigger: ["change", "blur"],
          },
        ],
        configKey: [
          {
            required: true,
            message: "请输入参数键名",
            whitespace: true,
            trigger: ["change", "blur"],
          },
        ],
        configValue: [
          {
            required: true,
            message: "请输入参数键值",
            whitespace: true,
            trigger: ["change", "blur"],
          },
        ],
        configType: [
          {
            required: true,
            message: "请输入系统内置",
            whitespace: true,
            trigger: ["change", "blur"],
          },
        ],
      },
      //label和wrapper的占位
      labelCol: { span: 5 },
      wrapperCol: { span: 19 },
      //新增和编辑弹出框的标题
      title: "",
      //新增和编辑弹出框的显示隐藏
      visible: false,
      //系统内置列表
      configTypeList: [],
    };
  },
  methods: {
    //获取系统内置列表
    getConfigTypeList() {
      this.getDictDataList("system_yes_no").then((res) => {
        this.configTypeList = res.data;
      });
    },
    //获取参数列表
    getConfigList() {
      getConfigList(this.queryParams).then((res) => {
        this.data = res.data;
        this.total = res.count;
        this.multiple = !this.selectedRowKeys.length;
      });
    },
    //搜索
    handleQuery() {
      this.queryParams.page = 1;
      this.getConfigList();
    },
    //搜索重置
    resetQuery() {
      this.queryParams.page = 1;
      this.$refs.queryForm.resetFields();
      this.getConfigList();
    },
    //刷新缓存
    refreshCache() {
      refreshCache().then((res) => {
        this.$message.success("刷新成功");
      });
    },
    //复选框状态改变
    onSelectChange(selectedRowKeys, records) {
      // console.log(selectedRowKeys);
      // console.log(records);
      this.selectedRowKeys = selectedRowKeys;
      this.multiple = !selectedRowKeys.length;
    },
    /** 新增按钮操作 */
    handleAdd() {
      this.form = {};
      this.visible = true;
      this.title = "新增参数";
    },
    /** 修改按钮操作 */
    handleUpdate(row) {
      this.form = {};
      getConfig(row.id).then((res) => {
        this.form = res.data;
        this.visible = true;
        this.title = "修改参数";
      });
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      this.$confirm({
        title: "您确认删除您选中的数据吗？",
        onOk: () => {
          //单个删除
          if (row.id) {
            let arr = [];
            arr.push(row.id);
            configRemove(arr).then((res) => {
              this.$message.success("删除成功");
              this.getConfigList();
            });
          }
          //批量删除
          else {
            configRemove(this.selectedRowKeys).then((res) => {
              this.$message.success("删除成功");
              this.selectedRowKeys = [];
              this.getConfigList();
            });
          }
        },
      });
    },
    //新增或编辑确定
    submit() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          configAddOrUpdate(this.form).then((res) => {
            //修改
            if (this.form.id) {
              this.$message.success("修改成功");
            }
            //新增
            else {
              this.$message.success("新增成功");
            }
            this.visible = false;
            this.getConfigList();
          });
        }
      });
    },
    //新增或编辑取消
    handleCancel() {
      this.$refs.ruleForm.resetFields();
      this.visible = false;
    },
    //分页状态改变
    onChange(pageNumber) {
      this.queryParams.page = pageNumber;
      this.getConfigList();
    },
    //改变分页上一步下一步的文字链接
    itemRender(current, type, originalElement) {
      if (type === "prev") {
        return <a>上一页</a>;
      } else if (type === "next") {
        return <a class="next">下一页</a>;
      }
      return originalElement;
    },
  },
  created() {
    this.getConfigList();
    this.getConfigTypeList();
  },
};
</script>

<style scoped lang="less"></style>
